export enum USING_IS_STYLE {
  NO = 0,
  YES,
}

export const USING_IS_STYLE_MAP = {
  [USING_IS_STYLE.NO]: '',
  [USING_IS_STYLE.YES]: 'using-is-style',
};
